// src/components/customerModule/customers/customerExportFetchers.js
//
// Each fetcher takes a customerguid and resolves to an ARRAY of row objects —
// the same shape the matching tab renders. A fetcher that throws does not break
// the export: that sheet is written empty and the failure lands on Summary.

import { getcustomerprofilebyguid } from "../../../services/customerinfoModule/profileServices";
import { getcustomernotes } from "../../../services/customerinfoModule/notesServices";
import {
    getcustomerdataset,
    getcustomerpayments,
    getcustomerhistory,
    getcustomertexts,
    getcustomeroptin,
} from "../../../services/customerinfoModule/historyServices";

export const fetchProfileRows = async (customerguid) => {
    const data = await getcustomerprofilebyguid({ customerguid });
    const profile = data?.[0];
    return profile ? [profile] : [];
};

export const fetchDatasetRows = async (customerguid) =>
    (await getcustomerdataset({ customerguid })) || [];

export const fetchNotesRows = async (customerguid) =>
    (await getcustomernotes({ customerguid })) || [];

// paymentType null = every event, matching the tab's non-dash view.
export const fetchPaymentsRows = async (customerguid) =>
    (await getcustomerpayments({ customerguid, paymentType: null })) || [];

export const fetchHistoryRows = async (customerguid) =>
    (await getcustomerhistory({ customerguid })) || [];

export const fetchTextsRows = async (customerguid) =>
    (await getcustomertexts({ customerguid })) || [];

export const fetchOptOutRows = async (customerguid) =>
    (await getcustomeroptin({ customerguid })) || [];